import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import Carouselhome from '../home/carousel-home';
import Teleperformance1 from '../../images/Project_Images/project-teleperformance1.webp';
import Teleperformance2 from '../../images/projects-slider/project-teleperformance2.webp';
import Teleperformance3 from '../../images/projects-slider/project-teleperformance3.webp';
import ScrollToTopButton from '../ScrollButton';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
function Acoustictele() {

    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };


    return (

        <>
            <Helmet>
                <title>About Our Teleperformance SE Acoustics Project</title>
                <meta name="description" content="" />
                <meta property="og:title" content="Teleperformance SE" />
                <meta property="og:description" content="Supply & Installation of D'ecopanel." />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/Teleperformance.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/acoustic-projects/project-teleperformance" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/acoustic-projects/project-teleperformance" hreflang="en-in" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="IN" />
                <meta name="geo.region" content="india" />
            </Helmet>
            <Header />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                            </div>
                            <div className="image-slider pro-content">
                                <div id="caption-slide" className="slider-container">
                                    <div className="slider">
                                        <Slider {...settings} ref={sliderRef}>
                                            <div className="slide">
                                                <img src={Teleperformance1} className="img-fluid" alt="Teleperformance1" />
                                            </div>
                                            <div className="slide">
                                                <img src={Teleperformance2} className="img-fluid" alt="Teleperformance2" />
                                            </div>
                                            <div className="slide">
                                                <img src={Teleperformance3} className="img-fluid" alt="Teleperformance3" />
                                            </div>
                                        </Slider>
                                    </div>
                                    <div className="switch slider-arrow" id="prev" onClick={goToPrev} style={{ backgroundColor: "transparent" }}><span>&#10094;</span></div>
                                    <div className="switch slider-arrow" id="next" onClick={goToNext} style={{ backgroundColor: "transparent" }}><span>&#10095;</span></div>
                                </div>
                            </div>
                            <div className="row pro-content">
                                <div className="col-sm-12 writeup">
                                    <h3>Teleperformance SE.</h3>
                                    <p className="note">Location: INDORE, MP</p>
                                    <p><strong>About Teleperformance Acoustic Project</strong><br />
                                        Teleperformance SE, headquartered in France, stands as a global leader in omnichannel customer experience management. Spanning operations in 91 countries, they excel in seamless customer interactions across diverse markets. From customer acquisition to technical support, debt collection, and social media services, Teleperformance leaves no stone unturned in delivering exceptional experiences.<br />
                                    </p>
                                    <p> <strong>Our Scope</strong><br />
                                        In this dynamic setting we supplied and expertly installed D’ecopanel—an acoustic marvel that transcends mere functionality. D’ecopanel seamlessly blends aesthetics and sound control, transforming spaces into havens of tranquility and style.
                                    </p>
                                    <br />
                                    <hr />
                                </div>
                            </div>
                            <div className="col-sm-12 ourprojects">
                                <h5>OUR PROJECTS</h5>
                                <p style={{ margin: "15px" }}><b>We deliver high-performance acoustic solutions with precision, innovation, and quality craftsmanship.
                                    Explore our recently completed projects that reflect our expertise across diverse spaces.</b></p>
                                <div id="mixedSlider">
                                    <div className="MS-content">
                                        <Carouselhome />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    );
}
export default Acoustictele;